export interface SUB_ID_TYPES {
  SINGLE: string;
  MONTHLY: string;
  YEARLY: string;
  UNIVERSE_MONTHLY_SUB_ID?: string;
  UNIVERSE_YEARLY_SUB_ID?: string;
}

// Universal subscriptions
export const UNIVERSE_MONTHLY_SUB_ID = '792299';
export const UNIVERSE_YEARLY_SUB_ID = '792301';

export const KTS_SUB_ID = {
  SINGLE: '884893',
  MONTHLY: '879170',
  YEARLY: '879171',
  UNIVERSE_MONTHLY_SUB_ID,
  UNIVERSE_YEARLY_SUB_ID,
};

export const G2T_SUB_ID = {
  SINGLE: '674726',
  MONTHLY: '792297',
  YEARLY: '792296',
  UNIVERSE_MONTHLY_SUB_ID,
  UNIVERSE_YEARLY_SUB_ID,
};

export const S2N_SUB_ID = {
  SINGLE: '670886',
  MONTHLY: '808823',
  YEARLY: '808824',
  UNIVERSE_MONTHLY_SUB_ID,
  UNIVERSE_YEARLY_SUB_ID,
};

export const P2N_SUB_ID = {
  SINGLE: '650761',
  MONTHLY: '787245',
  YEARLY: '815610',
  UNIVERSE_MONTHLY_SUB_ID,
  UNIVERSE_YEARLY_SUB_ID,
};

export const D2N_SUB_ID = {
  SINGLE: '853047',
  MONTHLY: '853029',
  YEARLY: '853025',
  UNIVERSE_MONTHLY_SUB_ID,
  UNIVERSE_YEARLY_SUB_ID,
};

export const SC2N_SUB_ID = {
  SINGLE: '904490',
  MONTHLY: '904491',
  YEARLY: '904492',
};

export const W2N_SUB_ID = {
  SINGLE: '913864',
  MONTHLY: '912628',
  YEARLY: '912629',
  UNIVERSE_MONTHLY_SUB_ID,
  UNIVERSE_YEARLY_SUB_ID,
};

export const V2N_SUB_ID = {
  SINGLE: '912624',
  MONTHLY: '912626',
  YEARLY: '912627',
  UNIVERSE_MONTHLY_SUB_ID,
  UNIVERSE_YEARLY_SUB_ID,
};
